import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#FAFAFA]">
        <Leaf className="h-10 w-10 text-[#1A362D] animate-pulse" />
      </div>
    );
  }

  if (!user) {
    sessionStorage.setItem("post_login_redirect", location.pathname);
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !user.is_admin) {
    return <Navigate to="/portal" replace />;
  }

  return children;
}
